export var TypeActionAuth;
(function (TypeActionAuth) {
    TypeActionAuth["Login"] = "Auth > Login";
    TypeActionAuth["NotificationLogin"] = "Auth > NotificationLogin";
})(TypeActionAuth || (TypeActionAuth = {}));
export var actionAuthLogin = function (playerId, token) { return ({
    playerId: playerId,
    token: token,
    type: TypeActionAuth.Login,
}); };
export var actionNotificationLogin = function () { return ({ type: TypeActionAuth.NotificationLogin }); };



//////////////////
// WEBPACK FOOTER
// ./src/features/auth/actionAuth.ts
// module id = 114
// module chunks = 3